module.exports = __webpack_public_path__ + "static/img/about-img.37c3e86.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-img.jpg
// module id = lcvK
// module chunks = 1